export const retrieveOrderHistory = () => {
    $.ajax({
        type: 'POST',
        cache: false,
        url: "/webapp/wcs/stores/servlet/MyDillardsOrderHistoryList",
        data: "storeId=301&langId=-1&catalogId=301",
        success: function(html) {
            $("#myDillardsDropdownDynamic").html(html);
        }
    });
};
